/* global axios */
/* eslint-disable max-classes-per-file */
import ApiClient from './ApiClient';

class BillingAPI extends ApiClient {
  constructor() {
    super('billing', { accountScoped: true });
  }

  getOverview(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.date_from) queryParams.append('date_from', params.date_from);
    if (params.date_to) queryParams.append('date_to', params.date_to);

    const queryString = queryParams.toString();
    const url = queryString ? `${this.url}?${queryString}` : this.url;
    return axios.get(url);
  }

  getTapCheckoutUrl(params) {
    return axios.post(`${this.url}/tap/checkout`, params);
  }

  getSubscriptionPreview(planId, couponCode = null) {
    const queryParams = new URLSearchParams({ plan_id: String(planId) });
    if (couponCode) queryParams.append('coupon_code', couponCode);
    return axios.get(
      `${this.url}/subscription/preview?${queryParams.toString()}`
    );
  }

  selectFreePlan(planId, options = {}) {
    const body = { plan_id: planId };
    if (options.coupon_code) {
      body.coupon_code = options.coupon_code;
    }
    return axios.post(`${this.url}/subscription/select_free_plan`, body);
  }

  previewLifetimeCoupon(code) {
    const q = new URLSearchParams({ code: code.trim() });
    return axios.get(`${this.url}/lifetime_coupons/preview?${q.toString()}`);
  }

  redeemLifetimeCoupon(code) {
    return axios.post(`${this.url}/lifetime_coupons/redeem`, {
      code: code.trim(),
    });
  }

  processTapCallback(params) {
    const queryString = new URLSearchParams(params).toString();
    return axios.get(`${this.url}/tap/callback?${queryString}`);
  }

  getCreditsCheckoutUrl(amount, couponCode = null) {
    return axios.post(`${this.url}/credits/checkout`, {
      amount,
      coupon_code: couponCode,
    });
  }

  purchaseCredits(amount, couponCode = null) {
    return axios.post(`${this.url}/credits/purchase`, {
      amount,
      coupon_code: couponCode,
    });
  }

  processWalletCallback(params) {
    const queryString = new URLSearchParams(params).toString();
    return axios.get(`${this.url}/tap/wallet-callback?${queryString}`);
  }

  getWalletTransactions(params = {}) {
    const queryParams = new URLSearchParams({
      page: params.page || 1,
      ...(params.transaction_type && {
        transaction_type: params.transaction_type,
      }),
      ...(params.deduction_type && { deduction_type: params.deduction_type }),
      ...(params.date_from && { date_from: params.date_from }),
      ...(params.date_to && { date_to: params.date_to }),
    });
    return axios.get(`${this.url}/wallet_transactions?${queryParams}`);
  }

  getDebitRecipients(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.wallet_transaction_id) {
      queryParams.append('wallet_transaction_id', params.wallet_transaction_id);
    }
    if (params.campaign_id) {
      queryParams.append('campaign_id', params.campaign_id);
    }
    if (params.page) {
      queryParams.append('page', String(params.page));
    }
    const debitRecipientsUrl = `${this.baseUrl()}/debit-recipients`;
    return axios.get(`${debitRecipientsUrl}?${queryParams}`);
  }

  async downloadDebitRecipientsCsv(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.wallet_transaction_id) {
      queryParams.append('wallet_transaction_id', params.wallet_transaction_id);
    }
    if (params.campaign_id) {
      queryParams.append('campaign_id', params.campaign_id);
    }
    const debitRecipientsUrl = `${this.baseUrl()}/debit-recipients`;
    const response = await axios.get(
      `${debitRecipientsUrl}/export?${queryParams}`,
      { responseType: 'blob' }
    );
    return response;
  }
}

class SubscriptionAPI extends ApiClient {
  constructor() {
    super('billing/subscription', { accountScoped: true });
  }

  manualCharge() {
    return axios.post(`${this.url}/manual_charge`);
  }
}

export const SubscriptionAPIInstance = new SubscriptionAPI();
export default new BillingAPI();
